import Container from '../(public-pages)/catalog/components/CatalogContainer'
import { TbCircleCheck } from 'react-icons/tb'
import { motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { GoCheckCircleFill } from "react-icons/go"

const PointList = ({ children }: { children: ReactNode }) => {
    return (
        <div className="flex items-center gap-2 ">
            <GoCheckCircleFill className="text-xl text-second" />
            <span>{children}</span>
        </div>
    )
}

const OtherFeatures = () => {
    return (
        <div className="relative z-20 ">
            <Container>
                <h2 className="text-xl lg:text-4xl mb-[48px] text-center">Дополнительные услуги</h2>
                <motion.div className=" rounded-3xl py-4 md:py-12  px-4 md:px-10 lg:px-16 lg:py-24 overflow-hidden mb-10">
                    <div className="grid lg:grid-cols-2 gap-8 lg:gap-4">
                        <div>
                            <h3 className="md:text-4xl">Широкий ассортимент спецодежды и СИЗ</h3>
                            <p className="mt-6 max-w-[550px] text-sm md:text-lg">
                                В ассортименте нашего магазина представлена
                                рабочая одежда для различных отраслей
                                промышленности. От спецобуви до головных уборов
                                - всё, что может понадобиться для обеспечения
                                безопасности на производстве. Все товары
                                сертифицированы и соответствуют высоким
                                стандартам качества. Покупая у нас, вы получаете
                                надёжные средства индивидуальной защиты,
                                разработанные с учётом последних тенденций и
                                технологий.
                            </p>
                            <div className="mt-12 flex flex-col gap-4">
                                <PointList>
                                    Рабочая одежда для защиты на производстве
                                </PointList>
                                <PointList>
                                    Спецобувь для различных условий работы
                                </PointList>
                                <PointList>
                                    Аксессуары и дополнительные средства защиты
                                </PointList>
                            </div>
                        </div>
                        <div className="relative flex justify-center">
                            <motion.div
                                whileHover={{ y: -20 }}
                                className="relative flex justify-center w-full"
                            >
                                <div className="p-4 border border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-700 rounded-[32px] max-w-[550px] lg:absolute ">
                                    <div className="absolute inset-x-0 bottom-0 h-20 w-full scale-[1.1] pointer-events-none" />
                                    <div className="bg-white dark:border-gray-700 border border-gray-200 rounded-[24px] p-2">
                                        <div className="relative h-[450px] w-full rounded-[24px] overflow-hidden">
                                            <img
                                                src="/image/catalog/spec.webp"
                                                alt="App screenshot"
                                                className="h-full w-full object-contain"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </motion.div>
                <motion.div className=" rounded-3xl  py-4 md:py-12  px-4 md:px-10 lg:px-16 lg:py-24 overflow-hidden mb-10">
                    <div className="grid lg:grid-cols-2 gap-8 lg:gap-4">
                        <div className="relative flex justify-center">
                            <motion.div
                                whileHover={{ y: -20 }}
                                className="relative flex justify-center w-full"
                            >
                                <div className="p-4 border border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-700 rounded-[32px] max-w-[550px] lg:absolute ">
                                    <div className="absolute inset-x-0 bottom-0 h-20 w-full scale-[1.1] pointer-events-none" />
                                    <div className="bg-white dark:border-gray-700 border border-gray-200 rounded-[24px] overflow-hidden p-2">
                                        <img
                                            src="/image/catalog/obuv.webp"
                                            alt="App screenshot"
                                        />
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                        <div className="pl-4">
                            <h3 className="md:text-4xl">
                                Гарантия защиты: соответствие международным
                                стандартам
                            </h3>
                            <p className="mt-6 max-w-[550px] text-sm md:text-lg">
                                Мы предлагаем только сертифицированную
                                продукцию, проверенную в самых сложных условиях.
                                Вся спецодежда соответствует ГОСТ, EN ISO и
                                имеет необходимые протоколы испытаний. Ваша
                                безопасность — наш приоритет, подтвержденный
                                документально.
                            </p>
                            <div className="mt-12 flex flex-col gap-4">
                                <PointList>сертификат</PointList>
                                <PointList>гарантия</PointList>
                                <PointList>уверенность</PointList>
                            </div>
                        </div>
                    </div>
                </motion.div>
                <motion.div className="rounded-3xl py-4 md:py-12  px-4 md:px-10 lg:px-16 lg:py-24 overflow-hidden mb-10">
                    <div className="grid lg:grid-cols-2 gap-8 lg:gap-4">
                        <div className="pr-4">
                            <h3 className="md:text-4xl">Нанесение логотипов</h3>
                            <p className="mt-6 max-w-[550px] text-sm md:text-lg">
                                Основным направлением деятельности компании
                                является поставка нашим клиентам спецодежды и
                                средств индивидуальной защиты от ведущих
                                Российских и зарубежных производителей. Мы
                                работаем напрямую с производителями и
                                импортерами. В дополнение к этому мы так же
                                предоставляем нашим клиентам услуги по нанесению
                                логотипов. Логотипы можно нанести на спецодежду,
                                головные уборы, каски, жилеты и многое другое.
                                Поскольку каждый логотип просчитывается
                                индивидуально, стоимость необходимо уточнить у
                                менеджера. Все работы осуществляются командой
                                профессионалов, имеющих многолетний опыт в
                                нанесении логотипов. За столь низкие цены мы
                                хотим предложить максимально короткие сроки,
                                удобное для Вас время и несравненное качество! В
                                зависимости от изделия мы делаем различное
                                нанесение:
                            </p>
                            <div className="mt-12 flex flex-col gap-4">
                                <PointList>термопечать</PointList>
                                <PointList>шелкография</PointList>
                                <PointList>вышивка</PointList>
                            </div>
                        </div>
                        <div className="relative flex justify-center">
                            <motion.div
                                whileHover={{ y: -20 }}
                                className="relative flex justify-center w-full"
                            >
                                <div className="p-4 border border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-700 rounded-[32px] max-w-[550px] lg:absolute ">
                                    <div className="absolute inset-x-0 bottom-0 h-20 w-full scale-[1.1] pointer-events-none" />
                                    <div className="bg-white dark:border-gray-700 border border-gray-200 rounded-[24px] p-2">
                                        <div className="relative h-[450px] w-full rounded-[24px] overflow-hidden">
                                            <img
                                                src="/image/landing/otherFeatures/services-2.webp"
                                                alt="App screenshot"
                                                className="h-full w-full object-contain"
                                            />

                                            <div
                                                className="absolute bottom-0 inset-x-0 h-24 bg-gradient-to-b
            from-transparent via-gray-100 to-gray-100
            dark:via-zinc-800/50 dark:to-gray-800
            pointer-events-none"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </motion.div>
                <motion.div
                    className="rounded-3xl py-4 md:py-12 lg:py-24 px-4 md:px-10 lg:px-16 overflow-hidden mb-10"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{
                        duration: 0.3,
                        type: 'spring',
                        bounce: 0.1,
                    }}
                    viewport={{ once: true }}
                >
                    <div className="grid lg:grid-cols-2 gap-8 lg:gap-4 items-center">
                        <div className="relative flex justify-center">
                            <motion.div
                                whileHover={{ y: -12 }}
                                className="relative flex justify-center w-full overflow-hidden"
                            >
                                <div className="relative p-4 border border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-700 rounded-[32px] max-w-[550px] ">
                                    <div className="absolute inset-x-0 bottom-0 h-20 w-full  scale-[1.1] pointer-events-none" />
                                    <div className="bg-white dark:border-gray-700 border border-gray-200 rounded-[24px] overflow-hidden p-2">
                                        <img
                                            src="/image/others/delivery.png"
                                            alt="App screenshot"
                                        />
                                    </div>
                                </div>
                            </motion.div>
                        </div>

                        <div className="pl-4">
                            <h3 className="md:text-4xl">
                                Отправка по всей России!
                            </h3>
                            <p className="mt-6 max-w-[550px] text-sm md:text-lg">
                                Каждый день мы отправляем десятки заказов в
                                разные города России — от небольших строительных
                                бригад до крупных предприятий. Люди выбирают наш
                                магазин спецодежды, потому что мы доказали:
                            </p>
                            <div className="mt-12 flex flex-col gap-4">
                                <PointList>
                                    качество не должно стоить дорого,
                                </PointList>
                                <PointList>
                                    доставка всегда быстрая и надёжная,
                                </PointList>
                                <PointList>
                                    а одежда — прочная, удобная и современная.
                                </PointList>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </Container>
        </div>
    )
}

export default OtherFeatures
